export default __webpack_public_path__ + "static/media/interface.217ccf89.png";